export default __webpack_public_path__ + "static/media/event-image.c42bb6ce.png";